import { z } from 'zod'

export const trainerSideEffectsExceptionResponseSchema = z.record(z.unknown())
export type TrainerSideEffectsExceptionResponse = z.infer<typeof trainerSideEffectsExceptionResponseSchema>
